export default __webpack_public_path__ + "static/media/icon-folder-grey.ad4b0a4a.svg";